import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '@fluentui/react-list-preview';
import { Button, Tooltip } from '@fluentui/react-components';
import { CopyRegular, EditRegular, DeleteRegular } from '@fluentui/react-icons';

import { AdTypes, AdTypeStrings } from '../../constants/ad-type';
import { ResponsiveSearchAdPreview } from './rsa-preview';
import { ResponsiveAdPreview } from './mma-preview';
import { DynamicSearchAdPreview } from './dsa-preview';

const AdPreviewComponents = {
  [AdTypes.ResponsiveSearch]: ResponsiveSearchAdPreview,
  [AdTypes.Responsive]: ResponsiveAdPreview,
  [AdTypes.DynamicSearch]: DynamicSearchAdPreview,
};

export const AdListItem = ({
  i18n,
  ad,
  enableCopy,
  onCopyAd,
  onEditAd,
  onDeleteAd,
}) => {
  const AdPreviewComponent = AdPreviewComponents[ad.Type];

  return AdPreviewComponent && (
    <ListItem
      value={ad.Id}
      className="ad-list-item"
      aria-label={i18n.getString(AdTypeStrings[ad.Type])}
    >
      <div className="ad-preview-overlay">
        <Tooltip content={i18n.getString(_TL_('Copy'))} relationship="label">
          <Button icon={<CopyRegular />} onClick={onCopyAd} disabled={!enableCopy} />
        </Tooltip>
        <Tooltip content={i18n.getString(_TL_('Edit'))} relationship="label">
          <Button icon={<EditRegular />} onClick={onEditAd} />
        </Tooltip>
        <Tooltip content={i18n.getString(_TL_('Delete'))} relationship="label">
          <Button icon={<DeleteRegular />} onClick={onDeleteAd} />
        </Tooltip>
      </div>
      <AdPreviewComponent
        i18n={i18n}
        ad={ad}
      />
    </ListItem>
  );
};

AdListItem.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ad: PropTypes.shape({
    Id: PropTypes.number,
    Type: PropTypes.string,
  }),
  enableCopy: PropTypes.bool,
  onCopyAd: PropTypes.func.isRequired,
  onEditAd: PropTypes.func.isRequired,
  onDeleteAd: PropTypes.func.isRequired,
};

AdListItem.defaultProps = {
  ad: {},
  enableCopy: false,
};
